

const breakfast = [
  
    {
    id: 1,
    name: "Veg Pettis",
    description:
      "Crispy golden brown, deep fried potato pastry, made of mashed potato, gram flour freshly grated coconut, peas, cashew nuts and raisins, garnished with fresh coriander and fennel seeds, served with coriander-mint yoghurt chutney",
    price: "£4.95"
  },
  {
    id: 2,
    name: "Khaman",
    description:
      "Popular snack from Gujarat (Western India), steamed Savory cake made from fermented batter of chickpea flour, lightly spiced with chilli/ginger/garlic paste and tempered with mustard seeds. Served with Besan (gram flour) chutney",
    price: "£4.90"
  },
  {
    id: 3,
    name: "Dhokla",
    description:
      "Popular snack from Gujarat (Western India), steamed Savory cake made from fermented batter of rice flour, toppled with red chilli powder and tempered with mustard seeds. Served with coriander and mint chutney",
    price: "£4.90"
  },
  {
    id: 4,
    name: "Patra",
    description:
      "Colocasia leaves (taro leaves) coated with a flavourful chickpea flour batter, steamed, and then tempered with spices",
    price: "£3.90"
  },
  {
    id: 5,
    name: "Methi Bhaji",
    description:
      "Popular Indian fritters - fenugreek leaves mixed in a spiced chickpea flour batter then deep fried for soft but crispy finish. Served with blended Sweet-Tangy & Coriander-mint Chutney",
    price: "£4.95"
  },
  {
    id: 6,
    name: "Potato Bhaji",
    description:
      "Popular Indian fritters - thin sliced potatoes mixed in a spiced chickpea flour batter then deep fried for soft but crispy finish. Served with blended Sweet-Tangy & Coriander-mint Chutney",
    price: "£4.65"
  },
  {
    id: 7,
    name: "Onion Bhaji",
    description:
      "Popular Indian fritters - thin sliced onions mixed in a spiced chickpea flour batter then deep fried for soft but crispy finish. Served with blended Sweet-Tangy & Coriander-mint Chutney",
    price: "£4.65"
  },
  {
    id: 8,
    name: "Mix Bhaji",
    description:
      "Combination of Methi/Potato/Onion bhaji. Served with blended Sweet-Tangy & Coriander-mint Chutney",
    price: "£4.75"
  },
  {
    id: 9,
    name: "Bread Pakoda (Bhaji)",
    description:
      "Slices of bread, stuffed with spiced potato mixture and coated in a gram flour batter - deep fried until golden and crispy",
    price: "£3.50"
  },
  {
    id: 10,
    name: "Vada Pau",
    description:
      "Most popular street food from Mumbai - spicy potato fritter (vada) nestled inside a soft bread roll (pav) with spicy chutneys. Served with fried green chili",
    price: "£3.85"
  },
  {
    id: 11,
    name: "Dabeli",
    description:
      "Dilkhush Special - spicy and sweet potato filling nestled inside a soft bread roll (pav) with sweet-tangy chutney, pomegranate seeds and Sev (crispy chickpea flour noodles) and peanuts",
    price: "£3.85"
  },
  {
    id: 12,
    name: "Pani Puri",
    description:
      "Mouth-watering Indian street food - Crispy puri cells filled with Savory mix of chickpeas, potatoes and spices and toppled with a tangy and flavourful tamarind-coriander water.",
    price: "£4.25"
  },
  {
    id: 13,
    name: "Bhel Puri",
    description:
      "Delightful mix of textures and flavours of puffed rice, corn flakes, crunch of Sev (crispy chickpea flour noodles) and other fried snacks together with softness of potatoes, onions and tomatoes - mixed with sweet-tangy chutney and chaat masala",
    price: "£5.25"
  },
  {
    id: 14,
    name: "Dahi Puri",
    description:
      "Crispy puri shells filled with delicious combination of mashed potatoes, chickpeas, sweet-tangy chutney and creamy yogurt and garnished with Sev and fresh coriander",
    price: "£4.95"
  },
  {
    id: 15,
    name: "Sev Puri",
    description:
      "Popular Indian street food - crispy puri cells toppled with mashed potatoes, chickpeas, sweet-tangy chutney and garnished with Sev, pomegranate seeds and Sev crispy chickpea flour noodles",
    price: "£4.95"
  },
  {
    id: 16,
    name: "Alu Puri / Puri Bhaji",
    description:
      "Deep-fried puffed bread (Puri) - served with a vibrant and aromatic potato curry (bhaji)",
    price: "£5.90"
  },
  {
    id: 16,
    name: "Panjabi Samosa",
    description:
      "Crispy, golden brown, triangle pastry - filled with lightly spiced mix of mashed potatoes, green peas, and garnished with coriander and funnel seeds - outer layer made of plain flour, semolina and ajwain (carom) seeds",
    price: "£4.50"
  },
  {
    id: 17,
    name: "Samosa Chat",
    description:
      "Partly mashed samosas, toppled with chickpeas, coriander-mint chutney, sweet-tangy chutney, chaat masala, yogurt, Sev, onion and tomatoes, garnished with fresh coriander",
    price: "£5.25"
  },
  {
    id: 18,
    name: "Paneer Hariyali Tikka",
    description:
      "Indian-cottage-cheese cubes marinated in coriander-mint chutney and flame-grilled - served with fresh salad (lettuce-cucumber)",
    price: "£6.50"
  },
  {
    id: 19,
    name: "Veg Manchurian (Dry)",
    description:
      "Indo-Chinese fusion - Fried vegetable (cabbage, carrots, pepper) balls tossed with tangy-spicy Manchurian sauce",
    price: "£6.90"
  },
  {
    id: 20,
    name: "Veg Hakka Noodles",
    description:
      "Indo-Chinese fusion - boiled noodles mixed with stir-fried vegetables (carrots, spring onions, peppers, cabbage) - lightly spiced and toppled with soya sauce and vinegar",
    price: "£6.50"
  },
  {
    id: 21,
    name: "Paneer Chili",
    description:
      "Deep fried paneer (Indian-cottage-cheese) cubes - tossed in a spice Savory sauce made of soy sauce, vinegar, sweet-chilli sauce, ginger and bell peppers",
    price: "£5.95"
  },
  {
    id: 22,
    name: "Vegetarian Momos - Fried",
    description:
      "Handmade dumplings - filled with blend of seasoned vegetables (carrots, cabbage, spring onion, pepper) - Deep fried for golden, brown and crispy finish. Served with Tomato Chutney",
    price: "£4.95"
  },
  {
    id: 23,
    name: "Vegetarian Momos - Steamed",
    description:
      "Handmade dumplings - filled with blend of seasoned vegetables (carrots, cabbage, spring onion, pepper) - steamed for healthier finish. Served with Tomato Chutney",
    price: "£4.95"
  },
  {
    id: 26,
    name: "Chicken Tawa Fry",
    description:
      "A flavourful dish featuring marinated tender chicken pieces cooked on a flat-wide griddle (tawa) - toppled with fresh coriander",
    price: "£7.25"
  },
  {
    id: 27,
    name: "Tandoori Chicken",
    description:
      "A popular Indian dish featuring a chicken quarter leg - marinated in aromatic spices and yogurt, then traditionally cooked in clay oven (tandoor) - toppled with cucumber - onions and lime",
    price: "£7.50"
  },
  {
    id: 28,
    name: "Chilli Chicken",
    description:
      "Deep fried boneless chicken pieces - tossed in a spicy Savory sauce made of soy sauce, vinegar, sweet chilli sauce and vegetables (cabbage, green pepper & spring onions) and garnished with fresh ginger",
    price: "£7.50"
  },
  {
    id: 29,
    name: "Pepper Chicken",
    description:
      "Boneless chicken pieces marinated in aromatic spices, with enriched black pepper flavour - tossed with onions, curry leaves",
    price: "£7.25"
  },
  {
    id: 30,
    name: "Chicken 65",
    description:
      "Deep fried boneless chicken pieces - tossed with spring onions and curry leaves and sesame seeds",
    price: "£7.25"
  },
  {
    id: 31,
    name: "Chicken Lollipop",
    description:
      "Crispy on the outside, juicy and succulent on the inside, these chicken lollipops are a delightful Indo-Chinese appetizer. Marinated in aromatic spices and then batter-fried.",
    price: "£6.95"
  },
  {
    id: 32,
    name: "Chicken Seekh Kabab",
    description:
      "Seasoned ground chicken and infused with fresh herbs then shaped around the skewers and cooked until tender and slightly charred",
    price: "£7.60"
  },
  {
    id: 34,
    name: "Chicken Chaat",
    description:
      "Diced chicken pieces cooked on pan with onions, tomatoes and exuberant spices - served with a medium size puri and fresh vegetables (onions and cabbage)",
    price: "£7.25"
  },
  {
    id: 35,
    name: "Chicken Hakka Noodles",
    description:
      "Indo-Chinese fusion - Stir-fried noodles with tender chicken pieces and vibrant vegetables and mild spicey sauce",
    price: "£7.90"
  },
  {
    id: 36,
    name: "Chicken Momos - Fried",
    description:
      "Handmade dumplings - filled with blend of minced chicken, pepper, onion and coriander and other spices - Deep fried for golden, brown and crispy finish. Served with Tomato Chutney",
    price: "£5.95"
  },
  {
    id: 37,
    name: "Chicken Momos - Steamed",
    description:
      "Handmade dumplings - filled with blend of minced chicken, pepper, onion and coriander and other spices - steamed for healthier finish. Served with Tomato Chutney",
    price: "£5.95"
  },
  {
    id: 38,
    name: "Lamb Tawa Fry",
    description:
      "Lamb tawa fry is a popular Indian dish known for its rich flavors and smoky aroma. It involves pan-frying pre-cooked lamb with spices and aromatics on a tawa (griddle).",
    price: "£8.95"
  },
  {
    id: 39,
    name: "Lamb Chops",
    description:
      "Homestyle Lamb Chops with Garlic & Herbs: Juicy lamb chops, seasoned with fresh garlic, rosemary, and thyme, pan-fried to perfection.",
    price: "£8.90"
  },
  {
    id: 40,
    name: "Lamb Seekh Kabab",
    description:
      "Minced lamb, infused with aromatic spices and fresh herbs then expertly shaped onto skewers and grilled to perfection, creating a smoky and flavourful finish.",
    price: "£8.70"
  },
  {
    id: 41,
    name: "Jheenga (Prawn) Stir Fry",
    description:
      "Prawn Stir Fry features succulent prawns stir-fried with a vibrant mix of crisp vegetables and a savory sauce.",
    price: "£9.25"
  },
  {
    id: 42,
    name: "Jheenga (Prawn) Chat",
    description:
      "Prawn pieces cooked on pan with onions, tomatoes and exuberant spices - served with a medium size puri and fresh vegetables (onions and cabbage)",
    price: "£9.50"
  }
];

export default breakfast;
